import { Fragment } from 'react';
import reactStringReplace from 'react-string-replace';
import { RESPONSE_FIELD_REGEX } from 'core/constants';
import { SafeHTML } from 'edrolo/domains/app';

const TemplateResponseFieldRenderer = ({ text, renderResponseField }) => {
  // splits the text into an array where the regex matches are replaced by input components
  // so it'll be like ['string', <input />, 'string', <input />] etc
  // when react renders such an array it just puts it all back together as a paragraph with the
  // new inputs inline.
  // for inexplicable reasons, reactStringReplace iterates odd numbers so we have to create our
  // own index..
  let customIndex = 0;
  const textComponents = reactStringReplace(
    text,
    RESPONSE_FIELD_REGEX,
    (match) => renderResponseField(customIndex++)
  );

  // as items can contain markup we wanna grab the remaining strings and directly render
  // them as html by wrapping in spans (there's no way to render raw html without wrapping)
  return textComponents.map((item, index) => {
    if (typeof item === 'string') {
      return (
        <SafeHTML as="span" key={index}>
          {item}
        </SafeHTML>
      );
    }
    return <Fragment key={index}>{item}</Fragment>;
  });
};

export default TemplateResponseFieldRenderer;
